var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgSoftwareDevelopmentIcon = function SvgSoftwareDevelopmentIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 75,
    height: 67,
    fill: "none",
    viewBox: "0 0 75 67"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3,
    d: "M6.725 65a4.67 4.67 0 0 1-3.341-1.42A4.9 4.9 0 0 1 2 60.155V7.218a5.3 5.3 0 0 1 1.495-3.685A5.04 5.04 0 0 1 7.087 2h60.726a5.01 5.01 0 0 1 3.575 1.525 5.28 5.28 0 0 1 1.487 3.667v52.59a5.3 5.3 0 0 1-1.495 3.685A5.04 5.04 0 0 1 67.788 65zM72.875 17.75H2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M9 12a2 2 0 1 0 0-4 2 2 0 0 0 0 4M16.278 12a2 2 0 1 0 0-4 2 2 0 0 0 0 4M23.555 12a2 2 0 1 0 0-4 2 2 0 0 0 0 4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3,
    d: "m51.612 31.077 9.45 9.692-9.45 9.693M23.264 31.077l-9.45 9.692 9.45 9.693M42.163 31.077l-9.45 19.385"
  })));
};
export default SvgSoftwareDevelopmentIcon;